import { fetchPath } from '..'
import {
  createBasket,
  createBasketLine,
  createUnitPriceNegotiation,
  deleteBasketLine,
  loadContactBasket,
  replaceUnitPriceNegotiation,
  submitBasket,
  unitPriceNegotiationFormatter,
} from './functions'
import loadAdditionalBasketDataFactory from './loadAdditionalBasketData'
import offerLineIriUnitQuantityMapFactory from './offerLineIriUnitQuantityMapFactory'

/**
 * @type {function(*): Promise<*>}
 */
export const loadAdditionalBasketData = loadAdditionalBasketDataFactory({ fetchPath, offerLineIriUnitQuantityMapFactory })
export {
  createBasket,
  loadContactBasket,
  submitBasket,
  createBasketLine,
  createUnitPriceNegotiation,
  replaceUnitPriceNegotiation,
  unitPriceNegotiationFormatter,
  deleteBasketLine,
}

export default {
  createBasket,
  loadContactBasket,
  loadAdditionalBasketData,
  submitBasket,
  createBasketLine,
  createUnitPriceNegotiation,
  replaceUnitPriceNegotiation,
  unitPriceNegotiationFormatter,
  deleteBasketLine,
}
